<template>
  <pack>
    <zt-title>敏感词管理</zt-title>
    <div class="desc">审核模式搜索屏蔽词，使用英文,隔开。</div>
    <el-form size="medium">
      <el-form-item>
        <zt-input class="mt12" v-model="words" type="textarea"></zt-input>
      </el-form-item>
      <el-form-item>
        <zt-button type="primary" @click="onSubmit">保存</zt-button>
        <span class="ml12" v-if="update_time">上次修改时间：{{update_time * 1000 | dateYMDHM}}</span>
      </el-form-item>
    </el-form>
  </pack>
</template>
<script>
import {admin_blockwords_info} from '@/api/admin_blockwords_info';
import {admin_blockwords_set} from '@/api/admin_blockwords_set';
import {dateYMDHM} from '@/filters/date';

export default {
  name: 'Sensitive',
  data() {
    return {
      words: '',
      update_time: null,
    }
  },
  filters: {
    dateYMDHM,
  },
  methods: {
    // 获取敏感词信息
    async getInfo() {
      const {data} = await admin_blockwords_info()
      if(data.error_code === 0) {
        this.words = data.data
        this.update_time = data.eidt_time
      }else {
        this.$message.error(data.error_message)
      }
    },
    // 保存
    async onSubmit() {
      let words = this.words
      if(typeof words === 'string') {
        words = words.replace('，', ',')
      }
      const {data} = await admin_blockwords_set(words)
      if(data.error_code === 0) {
        this.$message.success('保存成功')
        this.getInfo()
      }else {
        this.$message.error(data.error_message)
      }
    },
  },
  created() {
    this.getInfo()
  },
}
</script>
<style lang="scss" scoped>
.desc{
  color: $theme-textsecond;
  font-size: 14px;
  margin-bottom: 4px;
}
</style>
